import { ReactNode } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./profileHero.module.scss";

export type StatusVariant =
  | "active"
  | "inactive"
  | "ndis"
  | "licenceFree"
  | "licenceSelfPaid"
  | "licenceProviderPaid"
  | "neutral";

interface StatusPillProps {
  variant: StatusVariant;
  label: string;
  icon?: ReactNode;
  onClick?: () => void;
  ariaLabel?: string;
  tone?: string;
}

const variantClass: Record<StatusVariant, string> = {
  active: styles.pillActive,
  inactive: styles.pillInactive,
  ndis: styles.pillNdis,
  licenceFree: styles.pillLicenceFree,
  licenceSelfPaid: styles.pillLicenceSelfPaid,
  licenceProviderPaid: styles.pillLicenceProviderPaid,
  neutral: styles.pillNeutral
};

export default function StatusPill({ variant, label, icon, onClick, ariaLabel, tone }: StatusPillProps) {
  const isInteractive = typeof onClick === "function";
  const toneStyle = tone
    ? {
        backgroundColor: `${tone}14`,
        borderColor: `${tone}40`,
        color: tone
      }
    : undefined;
  const cls = `${styles.pill} ${tone ? "" : variantClass[variant]} ${isInteractive ? styles.pillInteractive : ""}`.trim();

  if (isInteractive) {
    return (
      <button
        type="button"
        className={cls}
        style={toneStyle}
        onClick={onClick}
        aria-label={ariaLabel || label}
      >
        {icon && <span className={styles.pillIcon}>{icon}</span>}
        <span className={styles.pillLabel}>{label}</span>
        <ExpandMoreIcon className={styles.pillChevron} />
      </button>
    );
  }

  return (
    <span className={cls} style={toneStyle} aria-label={ariaLabel || label}>
      {icon && <span className={styles.pillIcon}>{icon}</span>}
      <span className={styles.pillLabel}>{label}</span>
    </span>
  );
}
